var LayoutPerspective = require('./../layout/LayoutPerspective');
var dashboardTemplate = require('./dashboard-template.hbs');
var PatientSummaryView = require('./../patient-summary/PatientSummaryView');
var TodoListWidget = require('./TodoListWidget');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var AsideBehavior = require('./../aside/AsideBehavior');

var appointmentConfigurationModel = require('./../appointment-config/appointmentConfigurationModel');

/**
 * Perspective for the patient-portal dashboard
 *
 * @class DashboardView
 */
module.exports = LayoutPerspective.extend({
  template: dashboardTemplate,
  moduleNamespace: 'dashboard.todo',

  behaviors: {
    portalPerspectiveLayoutBehavior: PortalPerspectiveLayoutBehavior,
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: 'dashboard.todo.aside.header',
      asideContentMessageKey: 'dashboard.todo.aside',
      showLogo: true
    }
  },

  /**
   * @method initialize
   * @override
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient to render the data for.
   *   @param options.page {Number} the page number to display the todo list
   */
  initialize: function(options) {
    LayoutPerspective.prototype.initialize.apply(this);
    var summaryFieldTypes = PatientSummaryView.prototype.FIELD_TYPES;
    this._todoListView = new TodoListWidget({
      patientVecnaId: options.patientVecnaId
    });
    this._patientSummaryView = new PatientSummaryView({
      fields: [
        summaryFieldTypes.IDENTIFIERS,
        summaryFieldTypes.LAST_LOGIN_ATTEMPT
      ]
    });

    appointmentConfigurationModel.loadOnce();

    if (options && options.page) {
      this._todoListView.setPage(options.page);
    }
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    this.attachView('patient-summary', this._patientSummaryView);
    this.attachView('message-list', this._todoListView);
  },

  /**
   * @method setRouteContext set any context vars passed in by the router.
   * @param routeParameters {Object} hash of parameter names to values from the route.
   *   @param routeParameters.page {String} the one-based (human readable) page number of the page in the list to render.
   */
  setRouteContext: function(routeParameters) {
    if (this._todoListView && routeParameters && routeParameters.page) {
      this._todoListView.setPage(routeParameters.page);
    }
  },

  /**
   * @method _attached
   * @override
   * @private
   */
  _attached: function() {
    this.listenTo(appointmentConfigurationModel, 'load-complete', this.render);
  },

  /**
   * @method _detached
   * @override
   * @private
   */
  _detached: function() {
    this.stopListening(appointmentConfigurationModel, 'load-complete', this.render);
  }
});
